// Module
var code = "<div class=\"asset-widget-header\"> <general-setting class=\"icon-general\"></general-setting> <span>{{vm.mainTitle}}</span> </div> ";
// Exports
module.exports = code;